export const reportResumeDayTypes = {
  SET_REPORT_RESUME_DAY_FILTERS: 'SET_REPORT_RESUME_DAY_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};